import { images } from '../constants'; 

const taxis = [
    {
        id: 1,
        image: images.taxi1Gallery1,
        name: 'Economy Taxi',
        baseFare: 10,
        content: "Economy Taxi is a budget-friendly option for daily commutes and short trips within the city. It provides a reliable and economical means of transportation with a focus on comfort and efficiency. Our Economy Taxi fleet is well-maintained and regularly inspected to ensure a smooth and safe ride. With affordable rates and excellent service, it’s the perfect choice for anyone seeking a cost-effective travel solution.",
        gallery: {
            image1: images.taxi1Gallery1,
            image2: images.taxi1Gallery2,
            image3: images.taxi1Gallery3,
            image4: images.taxi1Gallery4,
        },
        details: {
            passengers: "4 passengers",
            luggages: "2 suitcases",
            fuelType: "Petrol",
            costPerMile: "$2 per mile",
            availability: "All days",
            operatingHours: "24/7"
        },
        description: "The Economy Taxi service is ideal for everyday travel and budget-conscious riders. Our fleet includes well-maintained vehicles that ensure a smooth and comfortable ride. Experience the convenience and affordability of our Economy Taxi service.",
        vehicleList: [
            "Toyota Corolla",
            "Honda Civic",
            "Ford Focus",
            "Nissan Sentra",
            "Kia Forte",
            "Chevrolet Cruze"
        ],
        additionalInfo: [
            "Economical and Efficient",
            "Comfortable Ride",
            "Regular Maintenance",
            "Safe and Reliable",
            "Affordable Rates",
            "Experienced Drivers",
            "Well-Maintained Vehicles",
            "24/7 Availability",
            "Easy Booking Process",
            "Flexible Payment Options"
        ],
        comments: [
            {
                id: 1,
                image: images.taxi1Review1,
                name: "Hedley Howarth",
                date: "Dec 11th, 2022",
                rating: 4.0,
                content: "Great service! The ride was smooth and the driver was very friendly. Highly recommended for city trips."
            },
            {
                id: 2,
                image: images.taxi1Review2,
                name: "Katrina Molloy",
                date: "Jan 1st, 2022",
                rating: 4.5,
                content: "Affordable and convenient. The Economy Taxi service exceeded my expectations for a budget option."
            }
        ]
    },
    {
        id: 2,
        image: images.taxi2Gallery1,
        name: 'Luxury Taxi',
        baseFare: 25,
        content: "Luxury Taxi offers a premium travel experience with high-end vehicles designed for ultimate comfort and style. Whether it's a business trip or a special occasion, our luxury fleet ensures a smooth, elegant, and sophisticated ride. Each vehicle is equipped with modern amenities to enhance your journey.",
        gallery: {
            image1: images.taxi2Gallery1,
            image2: images.taxi2Gallery2,
            image3: images.taxi2Gallery3,
            image4: images.taxi2Gallery4,
        },
        details: {
            passengers: "4 passengers",
            luggages: "3 suitcases",
            fuelType: "Petrol",
            costPerMile: "$3 per mile",
            availability: "All days",
            operatingHours: "24/7"
        },
        description: "Our Luxury Taxi service is designed for those who appreciate comfort, class, and high-end travel. With premium vehicles and top-tier service, you can enjoy a seamless and elegant ride every time.",
        vehicleList: [
            "BMW 5 Series",
            "Mercedes E-Class",
            "Audi A6",
            "Lexus ES",
            "Jaguar XF",
            "Volvo S90"
        ],
        additionalInfo: [
            "Premium Comfort",
            "Luxury Interiors",
            "Regular Maintenance",
            "Safe and Reliable",
            "Experienced Chauffeurs",
            "Well-Maintained Vehicles",
            "24/7 Availability",
            "Easy Booking Process",
            "Flexible Payment Options",
            "Complimentary Refreshments"
        ],
        comments: [
            {
                id: 1,
                image: images.taxi2Review1,
                name: "James Whitmore",
                date: "Feb 5th, 2023",
                rating: 5.0,
                content: "An amazing experience! The taxi was spotless, the ride was smooth, and the service was top-notch. Highly recommended for business trips."
            },
            {
                id: 2,
                image: images.taxi2Review2,
                name: "Sophia Bennett",
                date: "Mar 15th, 2023",
                rating: 4.8,
                content: "Truly luxurious! The driver was professional, and the ride felt incredibly premium. Worth every penny."
            }
        ]
    },
    {
        id: 3,
        image: images.taxi3Gallery1,
        name: 'Shared Ride',
        baseFare: 8,
        content: "Shared Ride is the most economical travel option for budget-conscious passengers. Designed for shared commuting, this service offers a comfortable and cost-effective way to travel while splitting the fare with other riders. It's perfect for daily commutes, airport transfers, and city travel.",
        gallery: {
            image1: images.taxi3Gallery1,
            image2: images.taxi3Gallery2,
            image3: images.taxi3Gallery3,
            image4: images.taxi3Gallery4,
        },
        details: {
            passengers: "4 passengers",
            luggages: "1 suitcase",
            fuelType: "Petrol",
            costPerMile: "$1.50 per mile",
            availability: "All days",
            operatingHours: "24/7"
        },
        description: "Our Shared Ride service is a budget-friendly travel option for those looking to share rides and split costs. Ideal for short trips, airport shuttles, and daily commutes, this service ensures affordability without compromising on comfort.",
        vehicleList: [
            "Ford Connect",
            "Nissan NV200",
            "Toyota ProAce",
            "Chevrolet City Express",
            "Mercedes Metris",
            "Volkswagen Caddy"
        ],
        additionalInfo: [
            "Most Affordable Option",
            "Comfortable Seating",
            "Regular Maintenance",
            "Safe and Reliable",
            "Budget-Friendly Rates",
            "Experienced Drivers",
            "Well-Maintained Vehicles",
            "24/7 Availability",
            "Easy Booking Process",
            "Eco-Friendly Ride Sharing"
        ],
        comments: [
            {
                id: 1,
                image: images.taxi3Review1,
                name: "Michael Carter",
                date: "Jan 10th, 2023",
                rating: 4.2,
                content: "A great way to save money while getting around the city. The ride was smooth, and sharing the ride made it very affordable."
            },
            {
                id: 2,
                image: images.taxi3Review2,
                name: "Emma Roberts",
                date: "Feb 8th, 2023",
                rating: 4.0,
                content: "Perfect for daily commutes. The service was reliable, and the ride was comfortable even with multiple passengers."
            }
        ]
    },
    {
        id: 4,
        image: images.taxi4Gallery1,
        name: 'Airport Taxi',
        baseFare: 30,
        content: "Airport Taxi is designed for stress-free airport transfers with spacious vehicles and reliable service. Whether you're heading to or from the airport, our fleet ensures a smooth and comfortable ride with plenty of luggage space. Enjoy a hassle-free experience with punctual pickups and professional drivers.",
        gallery: {
            image1: images.taxi4Gallery1,
            image2: images.taxi4Gallery2,
            image3: images.taxi4Gallery3,
            image4: images.taxi4Gallery4,
        },
        details: {
            passengers: "4 passengers",
            luggages: "4 suitcases",
            fuelType: "Petrol",
            costPerMile: "$3.50 per mile",
            availability: "All days",
            operatingHours: "24/7"
        },
        description: "Our Airport Taxi service ensures timely and comfortable transportation to and from the airport. With spacious vehicles and professional drivers, you can count on a smooth, stress-free ride.",
        vehicleList: [
            "Chevrolet Suburban",
            "Toyota Highlander",
            "Ford Expedition",
            "Nissan Pathfinder",
            "Honda Pilot",
            "GMC Yukon"
        ],
        additionalInfo: [
            "Spacious and Comfortable",
            "Plenty of Luggage Space",
            "Punctual and Reliable",
            "Safe and Secure",
            "Professional Drivers",
            "Well-Maintained Fleet",
            "24/7 Availability",
            "Hassle-Free Booking",
            "Flight Tracking Assistance",
            "Seamless Airport Transfers"
        ],
        comments: [
            {
                id: 1,
                image: images.taxi4Review1,
                name: "David Martinez",
                date: "Mar 15th, 2023",
                rating: 4.8,
                content: "Very professional service! The driver was on time, and the ride was smooth. Plenty of space for my luggage."
            },
            {
                id: 2,
                image: images.taxi4eview2,
                name: "Sophia Allen",
                date: "Apr 2nd, 2023",
                rating: 4.7,
                content: "Made my airport transfer so easy! The taxi was clean, spacious, and super comfortable."
            }
        ]
    },
    {
        id: 5,
        image: images.taxi5Gallery1,
        name: 'Business Taxi',
        baseFare: 20,
        content: "Business Taxi offers a premium and comfortable travel experience for professionals on the go. Ideal for corporate travel, meetings, and executive rides, our Business Taxi fleet ensures a smooth and stylish journey with well-maintained luxury sedans and top-notch service.",
        gallery: {
            image1: images.taxi5Gallery1,
            image2: images.taxi5Gallery2,
            image3: images.taxi5Gallery3,
            image4: images.taxi5Gallery4,
        },
        details: {
            passengers: "4 passengers",
            luggages: "2 suitcases",
            fuelType: "Petrol",
            costPerMile: "$2.50 per mile",
            availability: "All days",
            operatingHours: "24/7"
        },
        description: "Our Business Taxi service is designed for professionals who require a reliable and stylish ride. With luxury sedans and top-tier comfort, it’s perfect for meetings, airport transfers, or executive travel.",
        vehicleList: [
            "Audi A6",
            "Volvo S60",
            "Mercedes C-Class",
            "BMW 3 Series",
            "Lexus ES",
            "Jaguar XE"
        ],
        additionalInfo: [
            "Luxury and Comfort",
            "Executive-Class Vehicles",
            "On-Time Arrivals",
            "Professional Chauffeurs",
            "Well-Maintained Fleet",
            "24/7 Availability",
            "Easy Online Booking",
            "Complimentary Wi-Fi",
            "Climate-Controlled Interior",
            "Smooth and Quiet Ride"
        ],
        comments: [
            {
                id: 1,
                image: images.taxi5Review1,
                name: "Michael Reynolds",
                date: "Feb 10th, 2023",
                rating: 4.8,
                content: "The best choice for business trips! The taxi was clean, comfortable, and the driver was very professional."
            },
            {
                id: 2,
                image: images.taxi5Review2,
                name: "Emily Carter",
                date: "Mar 5th, 2023",
                rating: 4.7,
                content: "Very professional service. I booked it for a meeting, and everything went smoothly. Highly recommend!"
            }
        ]
    },
    {
        id: 6,
        image: images.taxi6Gallery1,
        name: 'Minivan Taxi',
        baseFare: 15,
        content: "Minivan Taxi is the perfect choice for families, group travel, and those who need extra space. With seating for up to seven passengers and ample luggage capacity, it offers a comfortable and cost-effective transportation option.",
        gallery: {
            image1: images.taxi6Gallery1,
            image2: images.taxi6Gallery2,
            image3: images.taxi6Gallery3,
            image4: images.taxi6Gallery4,
        },
        details: {
            passengers: "7 passengers",
            luggages: "4 suitcases",
            fuelType: "Petrol",
            costPerMile: "$2 per mile",
            availability: "All days",
            operatingHours: "24/7"
        },
        description: "Ideal for group travel, our Minivan Taxi provides a spacious and comfortable ride. Whether you're heading to the airport, a family event, or a group outing, enjoy the convenience and affordability of our minivan service.",
        vehicleList: [
            "Honda Odyssey",
            "Kia Carnival",
            "Toyota Sienna",
            "Chrysler Pacifica",
            "Ford Transit Connect",
            "Mercedes-Benz Metris"
        ],
        additionalInfo: [
            "Spacious and Comfortable",
            "Ideal for Group Travel",
            "Ample Luggage Space",
            "Safe and Reliable",
            "Well-Maintained Vehicles",
            "Experienced Drivers",
            "24/7 Availability",
            "Affordable Group Fare",
            "Child Seat Option Available",
            "Smooth and Quiet Ride"
        ],
        comments: [
            {
                id: 1,
                image: images.taxi6Review1,
                name: "David Peterson",
                date: "Apr 18th, 2023",
                rating: 4.6,
                content: "Great choice for family trips! Plenty of space and a comfortable ride. Will book again."
            },
            {
                id: 2,
                image: images.taxi6Review2,
                name: "Sophia Martinez",
                date: "May 2nd, 2023",
                rating: 4.5,
                content: "Affordable and spacious. The perfect option for our group outing!"
            }
        ]
    }
];

export default taxis;